var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRazor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.075,55.537l-31.52-31.52c-1.046-1.046-2.436-1.622-3.915-1.622s-2.869,0.576-3.915,1.622l-8.801,8.801 c-1.046,1.046-1.622,2.436-1.622,3.915s0.576,2.869,1.622,3.915l31.52,31.52c0,0,0,0,0,0.001c1.08,1.078,2.498,1.618,3.915,1.618 c1.418,0,2.836-0.54,3.915-1.619l8.801-8.802c1.046-1.046,1.622-2.436,1.622-3.914C73.697,57.973,73.121,56.583,72.075,55.537z  M69.247,60.538l-8.801,8.802c-0.6,0.598-1.574,0.599-2.174-0.001L26.753,37.82c-0.599-0.6-0.599-1.574,0-2.174l8.801-8.801 c0.581-0.58,1.592-0.581,2.173,0l31.52,31.52C69.846,58.965,69.846,59.938,69.247,60.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.745,57.01l1.42-1.42c0.781-0.78,0.781-2.047,0-2.828s-2.047-0.781-2.828,0l-1.42,1.42l-6.089-6.089l1.42-1.42 c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L48,45.264l-6.089-6.089l1.42-1.42 c0.781-0.781,0.781-2.047,0-2.828c-0.78-0.781-2.048-0.781-2.828,0l-1.42,1.42l-2.742-2.742c-0.781-0.781-2.048-0.781-2.828,0 c-0.781,0.781-0.781,2.047,0,2.828l2.742,2.742l-1.42,1.42c-0.781,0.781-0.781,2.047,0,2.828c0.39,0.391,0.902,0.586,1.414,0.586 s1.024-0.195,1.414-0.586l1.42-1.42l6.089,6.089l-1.42,1.419c-0.781,0.781-0.781,2.047,0,2.828c0.39,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586L48,50.92l6.089,6.089l-1.42,1.419c-0.781,0.78-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586l1.42-1.419l2.742,2.742c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 c0.781-0.781,0.781-2.047,0-2.828L59.745,57.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRazor);
export default __webpack_public_path__ + "static/media/razor.2a6f222357ebc863feec880221ccf0f6.svg";
export { ForwardRef as ReactComponent };